module.exports = __webpack_public_path__ + "img/P58-en.3a31945e.png";